<mat-toolbar class="dhl-gradient-horizontal sticky-toolbar">
  <input *ngIf="true" type="checkbox" id="menu" #menu />
  <mat-toolbar-row class="menu-w">
    <div (click)="navigationSidenav.toggle()" class="d-block d-md-none dhl-hamburger-menu">
      <div class="hamburger-line hamburger-line-1" [@hamburguerX]="isHamburguer ? 'hamburguer' : 'topX'"></div>
      <div class="hamburger-line hamburger-line-2" [@hamburguerX]="isHamburguer ? 'hamburguer' : 'hide'"></div>
      <div class="hamburger-line hamburger-line-3" [@hamburguerX]="isHamburguer ? 'hamburguer' : 'bottomX'"></div>
    </div>
    <img src="./assets/images/logo/DHL_logo_rgb_BG.svg" (click)="navigateToHome()" alt="DHL" class="dhl-logo logo-left" />
    <span *ngIf="isEnableMenu" class="toolbar-spacer"></span>

    <div *ngIf="isEnableOption && isLogued && selectedStore !== ''" class="header-top-items item-responsive">
      <ng-container *dhlAppPermission="{ profiles: [], permissions: [enumAppPermission.SelectStore] }">
        <mat-icon svgIcon="dhl-icon-store"></mat-icon>
        <span>{{ selectedStore }}</span>
      </ng-container>
    </div>

    <div *ngIf="isEnableOption && isLogued" class="header-top-items item-responsive">
      <mat-icon class="icon-head" svgIcon="dhl-icon-user-circle"></mat-icon>
      <span>¡Hola {{ session.fullName }}!</span>
    </div>

    <div *ngIf="isEnableOption && isLogued" (click)="showModalLogout()" class="header-top-items item-click item-responsive">
      <mat-icon class="icon-head">exit_to_app</mat-icon>
      <span>Cerrar sesión</span>
    </div>

    <div *ngIf="isEnableOption && isLogued" (click)="navigateToCart()" class="header-top-items item-click item-cart">
      <div class="div-notification-number-products">{{ numberOfProducts }}</div>
      <mat-icon class="icon-head icon-cart" svgIcon="dhl-icon-shopping-cart"></mat-icon>
      <span class="item-responsive">Carrito</span>
    </div>

    <div
      *ngIf="isLogued == false && isDifferentOfLoginPage"
      [routerLink]="['/clients/create-account']"
      routerLinkActive="router-link-active"
      class="header-top-items item-click item-responsive">
      <span>Cree una cuenta</span>
    </div>

    <div
      *ngIf="isLogued == false && isDifferentOfLoginPage"
      [routerLink]="['/authentication/login']"
      routerLinkActive="router-link-active"
      class="header-top-items item-click item-responsive">
      <span>Iniciar sesión</span>
    </div>

    <div *ngIf="isLogued == false && isDifferentOfLoginPage" (click)="navigateToCart()" class="header-top-items item-click item-cart">
      <div class="div-notification-number-products" *ngIf="numberOfProducts > 0">{{ numberOfProducts }}</div>
      <mat-icon class="icon-head icon-cart" svgIcon="dhl-icon-shopping-cart"></mat-icon>
      <span class="item-responsive">Carrito</span>
    </div>
  </mat-toolbar-row>

  <mat-toolbar-row *ngIf="isLogued" class="dhl-horizontal-menu d-none d-md-flex justify-content-center">
    <ng-container *ngFor="let option of menuOptions">
      <span
        *ngIf="option.submenu && option.submenu.length > 0"
        [ngClass]="{ 'dhl-horizontal-menu-active': isChildRouteActive(option.submenu), '': !isChildRouteActive(option.submenu) }">
        <button mat-button [matMenuTriggerFor]="menu.subMenu" routerLinkActive="dhl-horizontal-menu-active">
          {{ option.menuName }}
          <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
        </button>
        <dhl-menu-horizontal-item #menu [options]="option.submenu"></dhl-menu-horizontal-item>
      </span>
      <span
        *ngIf="!option.submenu || option.submenu.length === 0"
        [ngClass]="{ 'dhl-horizontal-menu-active': isCurrentUrl(option), '': !isCurrentUrl(option) }"
        routerLinkActive="dhl-horizontal-menu-active"
        [routerLinkActiveOptions]="{ exact: true }">
        <button mat-button [routerLink]="option.url">
          {{ option.menuName }}
        </button>
      </span>
    </ng-container>
  </mat-toolbar-row>
</mat-toolbar>
<mat-sidenav-container autosize>
  <mat-sidenav #navigationSidenav (openedStart)="onToggleMenu($event)" (closedStart)="onToggleMenu($event)" mode="over" role="navigation" class="d-block d-md-none">
    <div *ngIf="isEnableOption && isLogued" class="row pt-5 pb-4 ps-3 pe-3">
      <div class="col text-center">
        <h3>{{ session.fullNameResponsive }}</h3>
      </div>
    </div>
    <mat-nav-list class="dhl-menu-item">
      <mat-list-item
        *ngIf="isLogued == false && isDifferentOfLoginPage"
        (click)="navigationSidenav.toggle()"
        [routerLink]="['/authentication/login']"
        routerLinkActive="router-link-active">
        Iniciar sesión
      </mat-list-item>
      <ng-container *ngFor="let option of menuOptions">
        <ng-container *ngIf="option.submenu && option.submenu.length > 0">
          <mat-expansion-panel tabindex="-1" [class.mat-elevation-z0]="true" routerLinkActive="dhl-menu-active" class="dhl-menu-sidenav">
            <mat-expansion-panel-header tabindex="-1">{{ option.menuName }}</mat-expansion-panel-header>
            <dhl-menu-item #menu [options]="option.submenu" (closeSidenav)="navigationSidenav.toggle()"></dhl-menu-item>
          </mat-expansion-panel>
        </ng-container>
        <ng-container *ngIf="!option.submenu || option.submenu.length === 0">
          <mat-list-item (click)="navigationSidenav.close()" [routerLink]="[option.url]" tabindex="-1" routerLinkActive="dhl-menu-active">
            {{ option.menuName }}
          </mat-list-item>
        </ng-container>
      </ng-container>
      <mat-divider></mat-divider>
      <mat-list-item *ngIf="isEnableOption && isLogued" (click)="showModalLogout()" routerLinkActive="list-item-active"> Cerrar sesión </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content role="main">
    <div class="dhl-main-container">
      <router-outlet></router-outlet>
    </div>
    <dhl-footer-bar></dhl-footer-bar>
  </mat-sidenav-content>
</mat-sidenav-container>
